export const MAX_ITEMS = 50
export const MAX_TP_ITEMS = 50

// Values taken from proposal https://governance.decentraland.org/proposal/?id=f69c4d40-aaaf-11ec-87a7-6d2a41508231
export const TP_TRESHOLD_TO_REVIEW = 0.01
export const MAX_TP_ITEMS_TO_REVIEW = 300
export const MIN_TP_ITEMS_TO_REVIEW = 50
